import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import GridBlock from 'components/GridBlock';
import {getPaginationConfig} from "hooks/useSearch";
import Tr from "translations/Translations";

const useStyles = makeStyles(theme => ({
    info: {
        lineHeight: '2rem'
    }
}))

function MoreButton(
    {
        totalCount = 0,
        loadedCount = 0,
        setConfig = () => {
        },
        config = getPaginationConfig(),
        disabled = false,
        captionTrKey = 'showing_x_of_y_rows',
        label = Tr('load_more'),
    }) {
    const classes = useStyles();
    const handleChangePage = () => {
        setConfig({...config, page: config.page + 1});
    }

    return (
        <GridBlock
            alignItems='center'
            direction='column'
        >
            <Typography variant='caption' className={classes.info}>
                {Tr(captionTrKey, {count: loadedCount, total: totalCount})}
            </Typography>
            <Button
                variant={'outlined'}
                size={'small'}
                onClick={handleChangePage}
                disabled={disabled || (loadedCount >= totalCount)}
            >
                {label}
            </Button>
        </GridBlock>
    )
}

MoreButton.propTypes = {
    totalCount: PropTypes.number,
    loadedCount: PropTypes.number,
    setConfig: PropTypes.func,
    config: PropTypes.shape({
        page: PropTypes.number,
        pageSize: PropTypes.number
    }),
    disabled: PropTypes.bool,
    captionTrKey: PropTypes.string,
    label: PropTypes.string
}

export default MoreButton;